import { render, staticRenderFns } from "./UserPlaceholder.vue?vue&type=template&id=510c7885&scoped=true&"
import script from "./UserPlaceholder.vue?vue&type=script&lang=js&"
export * from "./UserPlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510c7885",
  null
  
)

export default component.exports